<img src="/assets/icons/logo_green.svg" alt="t1d-logo-green">
<h3 mat-dialog-title class="new-theme-info-title">New look. Same T1D Exchange Registry.</h3>
<div mat-dialog-content class="inner-text new-theme-info-des">
    <p>You’ll notice a refreshed look and feel on all T1D Exchange platforms, including on your registry dashboard!</p>

    <p>While some things look different, who we are and what we do stays the same – just with a new style.</p>
</div>
<div mat-dialog-actions>
    <button class="survey-button dialog-button is-shadowed" mat-flat-button color="primary" [mat-dialog-close]="true">
        Close
    </button>
</div>